<template>
    <div ref="dragCategoriesEl" class="categories-sorting scrollable-box">
        <div v-for="(category_id, index) in selectedCategories" :key="category_id" :data-index="index" style="cursor:move;">
            <i class="fa-solid fa-arrows-up-down"></i> {{ getCategoryName(category_id) }}
        </div>
    </div>
</template>
<script setup>
import { useDragAndDrop } from '@formkit/drag-and-drop/vue';
import { computed } from 'vue';
import { useNewsPaperStore } from '@/stores';

const newsPaperStore = useNewsPaperStore();

const props = defineProps(['newspaperCode', 'categories']);
const emit = defineEmits(['change']);

const categoriesData = computed({
    get() {
        return props.categories ?? [];
    },
    set(newValue) {
        emit('change', newValue);
    }  
});

const [ dragCategoriesEl, selectedCategories, config ] = useDragAndDrop(categoriesData, {});

const getCategoryName = (category_id) => {
    const [server_id, newspaper_id] = props.newspaperCode.split("-");
    return newsPaperStore.getCategoryName(server_id, newspaper_id, category_id)
}
</script>